import React from "react";
import { Row } from "react-bootstrap";

export const TableRegularRow = ({ children }: { children: React.ReactNode }) => {
    return (
        <Row className={"align-items-center my-4 pb-3 pb-md-0"}>{children}</Row>
    );
}